import React from "react";
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import moment from "moment";

import * as actionsCore from "../../actions/core";
import * as actionsBooking from "../../actions/booking";

import "./style.scss"

class BookingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            next: 0,
            items: []
        };

        this.isMount = true;
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    componentDidMount() {
        this.props.setShowLoad(true);
        this.props.bookingList(0).then(response => {
            if (this.isMount) {
                this.setState({
                    next: response.value.next,
                    items: response.value.items,
                })
            }
        }).catch(() => {
            this.props.addAlert("Что-то пошло не так");
        }).finally(() => {
            this.props.setShowLoad(false);
        });
    }

    moreHandle = () => {
        this.props.setShowLoad(true);
        this.props.bookingList(this.state.next).then(response => {
            if (this.isMount) {
                this.setState({
                    next: response.value.next,
                    items: _.concat(this.state.items, response.value.items),
                })
            }
        }).catch(() => {
            this.props.addAlert("Что-то пошло не так");
        }).finally(() => {
            this.props.setShowLoad(false);
        });
    };

    render() {
        return (
            <div className={"booking-page"}>
                <Typography className={"base-h4"} variant={"h4"}>Мои бронирования</Typography>
                <div className={"booking-page__items"}>
                    { this.state.items.map(item => {
                        return <Card key={item.id} className={"setting-history-page__items--item"}>
                            <CardContent>
                                <Typography>
                                    Бронирование №{ item.id } от { moment(item.createdAt).format("DD.MM.YYYY HH:mm") }
                                </Typography>
                                { item.cabinet && item.cabinet.office
                                    ? <Typography variant="body2">
                                        Офис: { item.cabinet.office.name }
                                    </Typography>
                                    : null
                                }
                                { item.cabinet
                                    ? <Typography variant="body2">
                                        Кабинет: { item.cabinet.name }
                                    </Typography>
                                    : null
                                }
                                <Typography variant="body2">
                                    { moment(item.date).format("DD.MM.YYYY") + " c " + (item.hour + "").padStart(2, "0") + (item.minute === "1/2" ? ":00" : ":30") + " по " + ((item.hour + (item.minute === "2/2" ? 1 : 0)) + "").padStart(2, "0") + (item.minute === "1/2" ? ":30" : ":00") }
                                </Typography>
                                <Typography variant={"h6"}>
                                    { item.sum } ₽
                                </Typography>
                            </CardContent>
                            { item.canCancel
                                ? <CardActions>
                                    <Button size={"small"} variant={"contained"} color="secondary" onClick={() => {
                                        this.props.setCancelBooking(item);
                                    }}>
                                        Отменить
                                    </Button>
                                </CardActions>
                                : null
                            }
                        </Card>
                    }) }
                    { this.state.next
                        ? <div className={"booking-page__more"}>
                            <Button color={"secondary"} variant={"contained"} onClick={() => {
                                this.moreHandle();
                            }}>Еще</Button>
                        </div>
                        : null
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        setLink: bindActionCreators(actionsCore.setLink, dispatch),
        addAlert: bindActionCreators(actionsCore.addAlert, dispatch),
        setCancelBooking: bindActionCreators(actionsCore.setCancelBooking, dispatch),
        setShowLoad: bindActionCreators(actionsCore.setShowLoad, dispatch),

        bookingList: bindActionCreators(actionsBooking.bookingList, dispatch),
    }
};

export default (connect(mapStateToProps, mapDispatchToProps)(BookingPage))
